import React, { useState, forwardRef, useImperativeHandle } from "react";
import AmountBadge from "./AmountBadge";
import CardLayout from "../common/CardLayout";

export default forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        getOriginalItems: () => {
            return originalItems;
        },
        setOriginalItems: ({ balance, income, expense }) => {
            setOriginalItems({ balance, income, expense });
            setBalance(balance);
            setIncome(income);
            setExpense(expense);
        },
        setItems: setItems,
        getItems: getItems
    }));

    const [balance, setBalance] = useState(null);
    const [income, setIncome] = useState(null);
    const [expense, setExpense] = useState(null);
    const [originalItems, setOriginalItems] = useState({});

    const incomeClicked = props.incomeClicked;
    const expenseClicked = props.expenseClicked;

    const setItems = ({ balance, income, expense }) => {
        if (balance) {
            setBalance(balance);
        }
        if (income) {
            setIncome(income);
        }
        if (expense) {
            setExpense(expense);
        }
    };

    const getItems = () => {
        return { balance, expense, income };
    };

    return (
        <CardLayout background={"#8884d8"} header={"מאזן"}>
            <div>
                <div style={{ display: "flex", flexDirection: "row" }}>
                    <div
                        style={{
                            flex: 3,
                            textAlign: "center",
                            direction: "RTL"
                        }}
                    >
                        <div
                            style={{
                                flex: 3,
                                color: "white",
                                fontWeight: "bold",
                                fontSize: 30,
                                direction: "ltr"
                            }}
                        >
                            {balance}₪
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        marginTop: "5px",
                        justifyContent: "center",
                        display: "flex",
                        flexDirection: "row"
                    }}
                >
                    <AmountBadge
                        clicked={incomeClicked}
                        text={"הכנסות"}
                        amount={income}
                        onClickCallback={props.incomeClickedCallback}
                    />
                    <AmountBadge
                        clicked={expenseClicked}
                        text={"הוצאות"}
                        amount={expense}
                        onClickCallback={props.expenseClickedCallback}
                    />
                </div>
            </div>
        </CardLayout>
    );
});
